import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { isNil, pathOr } from 'ramda'
import { Form, message } from 'antd'
import FacilityProfileV2 from 'model/facilities/facilityProfileV2'
import { checkForErrors } from 'utils/helpers'
import { Modal } from 'ui/styled'
import { composeVariables } from 'pages/Facility/FacilityHelpers'
import useFacilityCreate from 'apollo/mutations/Facilities/FACILITY_CREATE_MUTATION'
import useFacilityConfirmProfile from 'apollo/mutations/Facilities/FACILITY_CONFIRM_PROFILE'

import FacilityCreateForm from './FacilityCreateForm'

const RESPONSE_PATH = ['data', 'facilityCreate']

const FacilityCreateModal = ({ visible, onCancel }) => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const { onFacilityCreate } = useFacilityCreate()
  const { onFacilityConfirmProfile } = useFacilityConfirmProfile()

  const handleCancel = () => {
    onCancel()
    form.resetFields()
  }

  const onSave = async () => {
    form
      .validateFields()
      .then(async values => {
        const variables = composeVariables(values)
        if (!variables) {
          form.setFields([
            {
              name: 'address',
              errors: ['Please select a valid address from the list.']
            }
          ])
          throw new Error('Failed to parse the address')
        }

        const { r } = await onFacilityCreate({
          attributes: variables
        })
        const isValid = checkForErrors(RESPONSE_PATH, r, true)
        const facilityData = pathOr({}, RESPONSE_PATH, r)
        const facility = new FacilityProfileV2(facilityData)
        const { id, confirmed, confirmed_at } = facility
        // We have two types of errors: human-readable and ribbons errors
        // The next condition divides these errors and shows just human-readable
        if (isValid && id) {
          if (confirmed === false || isNil(confirmed_at)) {
            await onFacilityConfirmProfile({ id })
          }
          navigate(`/facilities/${id}`)
        } else if (!isValid && id) {
          message.error('Facility already exists at that address')
        } else {
          checkForErrors(RESPONSE_PATH, r)
        }
      })
      .catch(errorInfo => {
        console.warn(errorInfo)
      })
  }

  return (
    <Modal
      open={visible}
      title="New Facility"
      okText="Create"
      onOk={onSave}
      onCancel={handleCancel}
      overflowY="inherit"
    >
      <FacilityCreateForm form={form} />
    </Modal>
  )
}

FacilityCreateModal.propTypes = {
  onCancel: PropTypes.func,
  visible: PropTypes.bool
}

export default FacilityCreateModal
